/* Playably Case Studies (index) — play-type filter + scroll reveal. Load once. */
(function () {
  function filters(root) {
    root.querySelectorAll('.csi-filters').forEach(function (f) {
      if (f.__pa) return; f.__pa = true;
      var art = f.closest('.cn-art') || document;
      var grid = art.querySelector('.csi-grid');
      var mech = f.querySelectorAll('.pill[data-filter]');
      var goal = f.querySelectorAll('.pill[data-goal]');
      function setMech(v) {
        mech.forEach(function (x) { x.classList.toggle('active', (x.getAttribute('data-filter')) === v); });
        if (grid) grid.setAttribute('data-filter', v);
      }
      function setGoal(v) {
        goal.forEach(function (x) { x.classList.toggle('active', (x.getAttribute('data-goal')) === v); });
        if (grid) grid.setAttribute('data-goal', v);
      }
      function clearUc() {
        art.querySelectorAll('.csi-uc.active').forEach(function (u) { u.classList.remove('active'); });
      }
      mech.forEach(function (p) {
        p.addEventListener('click', function () {
          if (p.classList.contains('is-disabled')) return;
          clearUc(); setMech(p.getAttribute('data-filter') || 'all');
        });
      });
      goal.forEach(function (p) {
        p.addEventListener('click', function () { clearUc(); setGoal(p.getAttribute('data-goal') || 'all'); });
      });
      f.__setMech = setMech; f.__setGoal = setGoal; f.__clearUc = clearUc;
    });
    root.querySelectorAll('.csi-usecases').forEach(function (uc) {
      if (uc.__pa) return; uc.__pa = true;
      var art = uc.closest('.cn-art') || document;
      var f = art.querySelector('.csi-filters');
      var grid = art.querySelector('.csi-grid');
      uc.querySelectorAll('.csi-uc').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wasActive = btn.classList.contains('active');
          uc.querySelectorAll('.csi-uc').forEach(function (x) { x.classList.remove('active'); });
          if (wasActive) {
            if (f && f.__setMech) { f.__setMech('all'); f.__setGoal('all'); }
            return;
          }
          btn.classList.add('active');
          if (f && f.__setMech) {
            f.__setMech(btn.getAttribute('data-uc-filter') || 'all');
            f.__setGoal(btn.getAttribute('data-uc-goal') || 'all');
          }
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });
  }
  var SEL = '.cn-art .cn-eyebrow, .cn-art h1.cn-h1, .cn-art section h2.cn-h2, .cn-art .csi-hero-sub, .cn-art .csi-stat, .cn-art .csi-feature-card, .cn-art .csi-card, .cn-art .csi-cta-inner';
  function reduce() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function tag() {
    var els = document.querySelectorAll(SEL); if (!els.length) return;
    var vh = window.innerHeight || 800; var counts = new Map();
    els.forEach(function (el) {
      if (el.__rv) return; el.__rv = true; el.classList.add('pa-rv');
      var r = el.getBoundingClientRect();
      if (reduce() || (r.top < vh * 0.92 && r.bottom > 0)) { el.classList.add('pa-rv-in'); return; }
      var p = el.parentElement, idx = counts.get(p) || 0;
      if (idx > 0) el.style.transitionDelay = Math.min(idx * 70, 420) + 'ms';
      counts.set(p, idx + 1);
    });
  }
  function check() {
    var vh = window.innerHeight || 800;
    document.querySelectorAll('.cn-art .pa-rv:not(.pa-rv-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.86) el.classList.add('pa-rv-in');
    });
  }
  function revealStart() {
    if (window.__paCsiRv) return; window.__paCsiRv = true;
    if (!document.getElementById('pa-rv-style')) {
      var st = document.createElement('style'); st.id = 'pa-rv-style';
      st.textContent = '.cn-art .pa-rv{opacity:0;transform:translateY(28px);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1)}.cn-art .pa-rv.pa-rv-in{opacity:1;transform:none}@media (prefers-reduced-motion: reduce){.cn-art .pa-rv{opacity:1!important;transform:none!important;transition:none!important}}';
      document.head.appendChild(st);
    }
    var ticking = false;
    function onScroll(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ ticking=false; check(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    var last = 0;
    (function loop(ts){ if(!last||ts-last>120){last=ts;tag();check();} if(document.querySelector('.cn-art .pa-rv:not(.pa-rv-in)')||!document.querySelector('.cn-art')) requestAnimationFrame(loop); })();
  }

  function cardLinks(root) {
    root.querySelectorAll('.csi-card').forEach(function (c) {
      if (c.__pl) return; c.__pl = true;
      var l = c.querySelector('.csi-card-link') || c.querySelector('.csi-card-cta');
      var url = l && l.getAttribute('href');
      if (!url || url === '#') return;
      c.style.cursor = 'pointer';
      c.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        window.location.href = url;
      });
    });
  }

  function init(root) { root = root || document; filters(root); cardLinks(root); revealStart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
